import React, {useState, useEffect} from 'react'
import './taginput.css';

function TagInput(props) {
    const [value, setvalue]     = useState('');
    const [tagList, settagList] = useState([]);

    const [loading, setloading] = useState(true);

    const id = props.id ? props.id : 'taginput';

    useEffect(() => {
        if(loading){
            //if loading value
            if(props.defaultValue){
                //set default value
                if(typeof props.defaultValue === 'string' && props.defaultValue.length > 0){
                    let arrayValue  = props.defaultValue.split(',');
                    let newValues   = [];

                    //console.log('values', arrayValue);
                    arrayValue.map((item) => {
                        if(item !== ''){
                            newValues.push(item);
                        }
                    });

                    settagList(newValues);
                    setloading(false);

                    if(props.onChange){
                        let listString = newValues.length > 0 ? ','+newValues.toString()+',' : '';
                        props.onChange(listString);
                    }
                }
            }
        }
    }, [props.defaultValue, loading]);

    const changeTextInput = (e) => {
        const {value} = e.target;
        console.log(value.trim());

        if (
            e.key === 'Enter' 
            || e.keyCode === 13
            || e.code == "Space"     
            || e.keyCode == 32  
        ) {
            e.preventDefault();

            let trimValue = value.trim();
            if(trimValue !== ""){
                if(tagList.includes(trimValue)){
                    // no add becouse
                }else{
                    //add
                    let newTagList = [...tagList];
                    newTagList.push(trimValue);

                    settagList(newTagList);
                    if(props.onChange){
                        let listString = newTagList.length > 0 ? ','+newTagList.toString()+',' : '';
                        props.onChange(listString);
                    }
                    document.getElementById(id).value = "";
                }
            }
        }else if(e.keyCode == 8 || e.keyCode == 46 ){
            let trimValue = value.trim();
            if(trimValue !== ""){
                // borra
                return;
            }else{
                console.log('delete element');
                e.preventDefault();
                let newTagList = [...tagList];

                if(newTagList.length > 0){
                    let deleteLastElement = newTagList.pop();
                    settagList(newTagList);
                    if(props.onChange){
                        let listString = newTagList.length > 0 ? ','+newTagList.toString()+',' : '';
                        props.onChange(listString);
                    }
                }
            }
        }else{
            setvalue(value);
        }
    }

    const deleteTag = (item) => {
        let newList = tagList.filter(tag => tag !== item);
        settagList(newList);

        if(props.onChange){
            let listString = newList.length > 0 ? ','+newList.toString()+',' : '';
            props.onChange(listString);
        }
    }

    return (
        <div>
            <div className='taginput-container'>
                <div className='taginput'>
                    {tagList.length > 0 && tagList.map((item, key) => {
                        return <span className='tag' key={key}>
                            <span className='tagname'>{item}</span>
                            <button 
                                type='button' 
                                onClick={() => deleteTag(item)} 
                                className='tagbtn'
                            >x</button>
                        </span>
                    })}
                    <input 
                        id={id}
                        placeholder='Nueva palabra clave'
                        type="text" 
                        defaultValue={value}
                        onKeyDown={(e) => changeTextInput(e)}
                    />
                </div>
            </div>
            <p className='small-note'>
                Escriba y presione <strong>enter</strong> pasa agregar una palabra clave
            </p>
        </div>
    );
}

export default TagInput